export const flipCardDefaultStyles = {
  base: {
    includeFlipcardBackground: true,
    flipcardFrontColor: '#fff',
    flipcardBackColor: '#282A2B',
    flipcardFrontTextColor: '#282A2B',
    flipcardBackTextColor: '#fff',
    flipcardWidth: 300,
    flipcardHeight: 300,
    flipcardBorderRadius: 10,
    alignTextTop: 0,
  },
};

type TFlipCardDefaultStyles = {
  includeFlipcardBackground: boolean;
  flipcardFrontColor: string;
  flipcardBackColor: string;
  flipcardFrontTextColor: string;
  flipcardBackTextColor: string;
  flipcardWidth: number;
  flipcardHeight: number;
  flipcardBorderRadius: number;
  alignTextTop: 0 | 1 | boolean;
};

export const getDefaultStyles = (version = 'base') => {
  // throw. or return empty object with warning ???
  return (flipCardDefaultStyles[version] || {}) as TFlipCardDefaultStyles;
};
